import * as React from 'react';

export function useOnWindowPaste(onWindowPaste: (clipboardData?: DataTransfer | null) => void) {
	// Mantengo la última callback en un ref para no tener que volver a enganchar el listener global en cada render.
	const onWindowPasteRef = React.useRef(onWindowPaste);

	React.useEffect(() => {
		onWindowPasteRef.current = onWindowPaste;
	}, [onWindowPaste]);

	React.useEffect(() => {
		const listener = (event: ClipboardEvent) => {
			event.preventDefault();
			onWindowPasteRef.current(event.clipboardData);
		};

		window.addEventListener('paste', listener);
		return () => window.removeEventListener('paste', listener);
	}, []);
}
